import React from 'react'
import styled from '@emotion/styled'

import { DESKTOP_BREAKPOINT } from '@xfers/design-system'

type Props = {
  children?: React.ReactNode
  breadcrumb?: boolean
}

export default function({ children }: Props) {
  return (
    <>
      <PageContainer>{children}</PageContainer>
    </>
  )
}

const PageContainer = styled.div`
  background: #ffffff;
  ${DESKTOP_BREAKPOINT} {
    background: #f6f7f9;
  }
`
